import React from 'react';
import {
  TrendingUp,
  ArrowUpRight,
  ArrowDownRight,
  PieChart,
} from 'lucide-react';

export type ActivityType = 'capital_call' | 'distribution' | 'valuation';

interface ActivityIconProps {
  type: ActivityType;
  className?: string;
}

const getActivityIcon = (type: ActivityType) => {
  switch (type) {
    case 'capital_call':
      return ArrowUpRight;
    case 'distribution':
      return ArrowDownRight;
    case 'valuation':
      return PieChart;
    default:
      return TrendingUp;
  }
};

const getActivityIconBg = (type: ActivityType): string => {
  switch (type) {
    case 'capital_call':
      return 'bg-slate-100 text-slate-700';
    case 'distribution':
      return 'bg-green-100 text-green-600';
    case 'valuation':
      return 'bg-purple-100 text-purple-600';
    default:
      return 'bg-gray-100 text-gray-600';
  }
};

export function ActivityIcon({
  type,
  className = 'h-4 w-4',
}: ActivityIconProps) {
  const backgroundClasses = getActivityIconBg(type);

  return (
    <div className={`p-2 rounded-full ${backgroundClasses}`}>
      {React.createElement(getActivityIcon(type), { className })}
    </div>
  );
}
